import React from 'react';
import PropTypes from 'prop-types';
import { formatSignedCurrency } from '../../config/utils';
import './companyWallet.css';

const WalletSummaryBar = ({ summary, activeStatus, onSelect }) => {
    if (!summary) return null;

    const segments = [
        { key: null, label: 'All companies', count: summary.allCount, caption: 'Net balance', amount: formatSignedCurrency(summary.netBalance), tone: 'all' },
        { key: 'negative', label: 'Negative balance', count: summary.negativeCount, caption: 'Total owed', amount: formatSignedCurrency(summary.negativeTotal), tone: 'negative' },
        { key: 'zero', label: 'Zero balance', count: summary.zeroCount, caption: 'Cannot ship until topped up', amount: '', tone: 'zero' },
        { key: 'positive', label: 'Positive balance', count: summary.positiveCount, caption: 'Total held', amount: formatSignedCurrency(summary.positiveTotal), tone: 'positive' },
    ];
    const active = activeStatus || null;

    return (
        <div className="walletSummaryBar" data-testid="walletSummaryBar">
            {segments.map((segment) => (
                <button
                    type="button"
                    key={segment.label}
                    className={`walletSegment ${segment.tone} ${active === segment.key ? 'active' : ''}`}
                    aria-pressed={active === segment.key}
                    onClick={() => onSelect(segment.key)}
                >
                    <span className="walletSegmentLabel">{segment.label}</span>
                    <span className="walletSegmentCount">{segment.count ?? 0}</span>
                    <span className="walletSegmentAmount">
                        {segment.caption} {segment.amount && <b>{segment.amount}</b>}
                    </span>
                </button>
            ))}
        </div>
    );
};

WalletSummaryBar.propTypes = {
    summary: PropTypes.object,
    activeStatus: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
};

export default WalletSummaryBar;
